import { render, staticRenderFns } from "./SettingsAPI.vue?vue&type=template&id=4fd38b7e&scoped=true&"
import script from "./SettingsAPI.vue?vue&type=script&lang=js&"
export * from "./SettingsAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd38b7e",
  null
  
)

export default component.exports